/*
 * @Auther: 罗耀祖
 * @Date: 2022-08-24 14:28:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:46:45
 * @name: 工单接口
 * @Description: 工单接口
 * @FilePath: \preSaleNafterSaleBackstage\src\api\issue\issue.api.js
 * @Author: desktop
 */
import apiSearch from "../apiSearch.js";
import axios from 'axios';

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取工单列表
 */
export const issueGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/issue/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 推送工单到erp系统
 */
export const issuePushErp = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/issue/pushErp.html', data, instance);
}
